'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

var _FormValidationService = require('./../../../common/services/FormValidationService');

var _FormValidationService2 = _interopRequireDefault(_FormValidationService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VehicleAddSkupenetController = function () {
  function VehicleAddSkupenetController(lookupService, authService, enums, loadingService, $state, $stateParams) {
    "ngInject";

    (0, _classCallCheck3.default)(this, VehicleAddSkupenetController);
    this.lookupService = lookupService;
    this.authService = authService;
    this.enums = enums;
    this.loadingService = loadingService;
    this.formValidationService = new _FormValidationService2.default();
    this.$state = $state;
    this.$stateParams = $stateParams;

    if (this.$stateParams.skupenetId) {
      this.proceedToSkupenetEdit();
    } else {
      this.initializeEnumLookups();

      this.skupenetVehicle = {
        entityId: this.authService.authData.currentLocation.key,
        skupenetUserId: this.authService.authData.currentLocation.webPublisherUsername,
        registration: this.$stateParams.registration || this.getDefaultReg(),
        vehicleCondition: this.$stateParams.vehicleCondition,
        autoSold: this.$stateParams.autoSold,
        vehicleStatus: this.$stateParams.vehicleStatus
      };
    }
  }

  (0, _createClass3.default)(VehicleAddSkupenetController, [{
    key: 'initializeEnumLookups',
    value: function initializeEnumLookups() {
      var _this = this;

      var ctrl = this;
      ctrl.selectDefaults = {};

      var lookups = ['AutoSold', 'VehicleCondition', 'VehicleStatus'];
      this.enumLookupCollection = [];

      this.lookupService.lookupEnums(lookups).then(function (enumLookupCollection) {
        _this.enumLookupCollection = enumLookupCollection;

        (0, _lodash.map)(enumLookupCollection, function (itemsArray, index) {
          //Only leave Due In or In Stock for Vehicle Status
          if (index === 'vehicleStatus') {
            itemsArray.unshift({ id: null, name: 'Please Select' });
            enumLookupCollection['vehicleStatus'] = itemsArray.splice(0, 3);
          }

          itemsArray.unshift({ id: null, name: 'Please Select' });
        });

        _this.configureForm();
      });
    }
  }, {
    key: 'configureForm',
    value: function configureForm() {
      var ctrl = this;

      ctrl.formValidationService.initialize(ctrl.skupenetVehicle);

      ctrl.formValidationService.addField({
        fieldName: 'vehicleCondition',
        displayName: 'New or Used',
        type: 'select',
        required: true
      });

      ctrl.formValidationService.addField({
        fieldName: 'registration',
        displayName: 'Registration',
        type: 'text',
        required: true
      });

      ctrl.formValidationService.addField({
        fieldName: 'autoSold',
        displayName: 'Sale Type',
        type: 'select',
        required: true
      });

      ctrl.formValidationService.addField({
        fieldName: 'vehicleStatus',
        displayName: 'Status',
        type: 'select',
        required: true
      });
    }
  }, {
    key: 'getDefaultReg',
    value: function getDefaultReg() {
      var dt = new Date();

      var yr = dt.getFullYear().toString().substr(2, 2);
      var month = dt.getMonth() <= 5 ? 1 : 2;

      return '' + yr + month + 'D';
    }
  }, {
    key: 'proceedToSkupenet',
    value: function proceedToSkupenet() {
      var _this2 = this;

      if (!this.formValidationService.validateForm()) {
        return;
      }

      this.loadingService.showLoading('vehicleInfo', 'Creating Vehicle ...');

      this.authService.getSkupenetToken(this.skupenetVehicle).then(function (response) {
        var $form = $("<form></form>");
        $form.attr('method', 'post');
        $form.attr('action', 'http://www.easierad.ie/admin/thirdparty/api/edit');
        $form.append('<input type="submit" id="skupenetSubmit" formtarget="_blank" style="display:none;" />');
        $('body').append($form);

        $form.append('<input type="hidden" name="dpid" value="' + _this2.authService.authData.currentLocation.webPublisherUsername + '" />');
        $form.append('<input type="hidden" name="dpref" value="' + response.data.skupenetId + '" />');
        $form.append('<input type="hidden" name="token" value="' + response.data.token + '" />');
        $form.append('<input type="hidden" name="cat" value="428" />');
        $form.append('<input type="hidden" name="f50" value="' + _this2.skupenetVehicle.registration + '" />');
        $form.append('<input type="hidden" name="f18" value="" />');
        $form.append('<input type="hidden" name="f46" value="km" />');
        $form.append('<input type="hidden" name="f47" value="" />');
        $form.append('<input type="hidden" name="f197" value="" />');

        $('#skupenetSubmit').click();
        $form.remove();

        _this2.$state.go('welcomeCentre');
      }).finally(function () {
        _this2.loadingService.hideLoading('vehicleInfo');
      });
    }
  }, {
    key: 'proceedToSkupenetEdit',
    value: function proceedToSkupenetEdit() {
      var _this3 = this;

      this.authService.getSkupenetTokenEdit(this.$stateParams.skupenetId).then(function (response) {
        var $form = $("<form></form>");
        $form.attr('method', 'post');
        $form.attr('action', 'http://www.easierad.ie/admin/thirdparty/api/edit');
        $form.append('<input type="submit" id="skupenetSubmit" formtarget="_blank" style="display:none;" />');
        $('body').append($form);

        $form.append('<input type="hidden" name="dpid" value="' + _this3.authService.authData.currentLocation.webPublisherUsername + '" />');
        $form.append('<input type="hidden" name="dpref" value="' + _this3.$stateParams.skupenetId + '" />');
        $form.append('<input type="hidden" name="token" value="' + response.data.token + '" />');
        $form.append('<input type="hidden" name="cat" value="428" />');
        $form.append('<input type="hidden" name="f50" value="' + response.data.registration + '" />');
        $form.append('<input type="hidden" name="f18" value="' + _this3.$stateParams.price + '" />');
        $form.append('<input type="hidden" name="f48" value="" />');
        $form.append('<input type="hidden" name="f47" value="" />');
        $form.append('<input type="hidden" name="f197" value="' + _this3.$stateParams.color + '" />');

        $('#skupenetSubmit').click();
        $form.remove();

        _this3.$state.go('welcomeCentre');
      }).finally(function () {});
    }
  }]);
  return VehicleAddSkupenetController;
}();

exports.default = VehicleAddSkupenetController;


// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehicleAddSkupenet/vehicleAddSkupenet.controller.js